"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx6 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _commonI18n = require("@mmc/common-i18n");
var _text = require("@mmc/text");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _heroBrand = _interopRequireDefault(require("./hero-brand.props/hero-brand.propTypes"));
var _heroBrand2 = _interopRequireDefault(require("./hero-brand.props/hero-brand.defaultProps"));
var _heroBrandV = _interopRequireDefault(require("../styles/hero-brand-v2.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageTransforms = dataUtils.appendImageTransforms;
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var ctaData = function ctaData(data) {
  return {
    url: handleNestedProp(data, 'data.URL'),
    label: handleNestedProp(data, 'data.label'),
    priority: handleNestedProp(data, 'data.priority'),
    ctaTheme: handleNestedProp(data, 'data.theme'),
    openNewTab: handleNestedProp(data, 'data.openNewTab'),
    icon: handleNestedProp(data, 'data.icon'),
    ctaType: handleNestedProp(data, 'data.ctaType')
  };
};
var setTextWidth = function setTextWidth(alignment, theme) {
  if (alignment !== 'center') {
    return theme['col-xs-12'] + " " + theme['col-sm-8'] + " " + theme['col-md-6'] + " " + theme['col-lg-6'] + " " + _heroBrandV["default"].heroTextContent + " " + (_heroBrandV["default"][alignment] ? _heroBrandV["default"][alignment] : '');
  }
  return theme['col-xs-12'] + " " + _heroBrandV["default"].heroTextContent + " " + (_heroBrandV["default"][alignment] ? _heroBrandV["default"][alignment] : '');
};
var imageWidth = 480;
var getPrice = function getPrice(params) {
  var data = params.data,
    theme = params.theme,
    config = params.config;
  return data.price && /*#__PURE__*/_react["default"].createElement("h2", {
    className: (0, _clsx6["default"])(theme.headingFive, theme.marginBottom5, _heroBrandV["default"].heading3)
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: handleNestedProp(data, 'data.price.value'),
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      displayValue: handleNestedProp(data, 'data.price.displayValue'),
      zeroMessage: handleNestedProp(data, 'data.price.zeroMessage')
    },
    addPriceDisclaimer: handleNestedProp(data, 'data.addPriceDisclaimer'),
    priceDisclaimerId: handleNestedProp(data, 'data.priceDisclaimerId'),
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }));
};
var HeroTextBlock = function HeroTextBlock(_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4, _clsx5;
  var theme = _ref.theme,
    data = _ref.data,
    config = _ref.config,
    isMobile = _ref.isMobile;
  var _useState = (0, _react.useState)(null),
    navLinks = _useState[0],
    setNavLinks = _useState[1];
  var textBlockPosition = data.textBlockPosition,
    tag = data.tag,
    heading1 = data.heading1,
    heading2 = data.heading2,
    heading3 = data.heading3,
    cta = data.cta,
    vehicleLogo = data.vehicleLogo;
  var formatNavLinks = function formatNavLinks() {
    // Need to format links after mount in order to use 'window' only on the client and not server
    if (data.navigationLinks && data.navigationLinks.length > 0) {
      var _formattedLinks = data.navigationLinks.map(function (navLink) {
        var style = typeof window !== 'undefined' && window.location.href === navLink.url ? {
          backgroundColor: '#FFFFFF',
          color: '#000000'
        } : {};
        return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
          key: navLink.url,
          theme: theme,
          data: {
            priority: 'medium',
            label: navLink.label,
            url: navLink.url,
            openNewTab: navLink.openNewTab,
            ctaProps: {
              style: style
            }
          }
        });
      });
      setNavLinks(_formattedLinks);
    }
  };
  (0, _react.useEffect)(function () {
    formatNavLinks(data);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(theme['col-md-10'], theme['col-sm-10'], applyDarkTheme(data, theme), _heroBrandV["default"].heroTextWrapper, (_clsx = {}, _clsx[theme['col-lg-10']] = textBlockPosition !== 'center', _clsx[theme['col-lg-8']] = textBlockPosition === 'center', _clsx[_heroBrandV["default"][textBlockPosition]] = _heroBrandV["default"][textBlockPosition], _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(setTextWidth(textBlockPosition, theme), (_clsx2 = {}, _clsx2[_heroBrandV["default"].isDark] = data.theme === 'dark', _clsx2[_heroBrandV["default"].blackbg] = textBlockPosition === 'leftbackground', _clsx2))
  }, navLinks && navLinks.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_heroBrandV["default"].navigationLinks, _heroBrandV["default"][textBlockPosition])
  }, navLinks) : null, tag && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_heroBrandV["default"].tag, (_clsx3 = {}, _clsx3[_heroBrandV["default"].textAlignCenter] = textBlockPosition === 'center' || isMobile, _clsx3[_heroBrandV["default"].textAlignLeft] = textBlockPosition !== 'center' && !isMobile, _clsx3))
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.tags
  }, handleNestedProp(data, 'data.tag.label'))), vehicleLogo && /*#__PURE__*/_react["default"].createElement("div", {
    className: _heroBrandV["default"].logoWrapper
  }, vehicleLogo.image && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: appendImageTransforms(handleNestedProp(data, 'data.vehicleLogo.image'), imageWidth),
    alt: handleNestedProp(data, 'data.image.altText')
  })), heading1 && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: heading1,
    className: (0, _clsx6["default"])(theme.labelMedium, _heroBrandV["default"].heading1),
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: (0, _clsx6["default"])(theme.headingOne, _heroBrandV["default"].heading2),
    text: heading2,
    tag: "h1",
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), heading3 && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: (0, _clsx6["default"])(_heroBrandV["default"].textBlockWrapper, _heroBrandV["default"].textBlock, _heroBrandV["default"].heading3, (_clsx4 = {}, _clsx4[_heroBrandV["default"].darkBg] = textBlockPosition === 'leftbackground' && isMobile, _clsx4)),
    text: heading3,
    tag: isMobile ? 'h6' : 'h5',
    disclaimerData: handleNestedProp(data, 'data.disclaimerData')
  }), getPrice({
    data: data,
    theme: theme,
    config: config
  }), !isMobile && cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(applyDarkTheme(data, theme), _heroBrandV["default"].ctaWrapper, _heroBrandV["default"].ctaMargin, (_clsx5 = {}, _clsx5[_heroBrandV["default"].centerCta] = textBlockPosition === 'center', _clsx5))
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: ctaData(handleNestedProp(data, 'data.cta')),
    "data-section": heading1,
    classes: [applyDarkTheme(data, theme) + " " + (cta.priority === 'lowIcon' && _heroBrandV["default"].adjustIconPosition)]
  }))));
};
HeroTextBlock.defaultProps = {
  data: _heroBrand2["default"],
  config: {}
};
var _default = HeroTextBlock;
exports["default"] = _default;